import { render } from "./OrderSubmitted.vue?vue&type=template&id=62c97411&scoped=true"
import script from "./OrderSubmitted.vue?vue&type=script&lang=js"
export * from "./OrderSubmitted.vue?vue&type=script&lang=js"

import "./OrderSubmitted.vue?vue&type=style&index=0&id=62c97411&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c97411"]])

export default __exports__